import {useModal} from '../index';
import View from './view';
import {IModalDialog, Props} from './model';
import React from 'react';

export const ModalDialog = View;

export const useDialog = () => {
  const modal = useModal();
  return {
    showDialog: (props: Props): IModalDialog => {
      let close: () => void = () => {};
      const {hasOverlay, ...modalProps} = props;
      modal.show({
        hasOverlay,
        mobile: true,
        render({id: modalId}, methods) {
          close = () => {
            methods.remove(modalId);
          };

          return React.createElement(ModalDialog, {onClose: close, ...modalProps});
        },
      });
      return {
        close,
      };
    },
  };
};
